import styled from 'styled-components'

const HourRangeFilterInput = styled.div`
  label {
    color: var(--color-contrast-brand);
  }
`
export default HourRangeFilterInput
